export default "__VITE_ASSET__CXSmKzoU__"